export default {
  role: {
    itself: 'Role',
    '*': 'Role *',
    selectRole: 'Select role',
  },
};
